import React from "react";
import { QuestionCircleFilled } from "@ant-design/icons";
import { Minus, Plus } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";

interface FAQCardProps {
  question: string;
  answer: string;
}

const FAQCard: React.FC<FAQCardProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div
      className="bg-white shadow-lg rounded-lg p-6 cursor-pointer flex gap-4 items-center"
      onClick={() => setIsOpen(!isOpen)}
    >
      <QuestionCircleFilled className="text-3xl text-primary-blue mx-2" />

      <div>
        <h3
          className={`font-bold transition-all duration-300 ${
            isOpen ? "text-primary-blue mb-2" : "text-black"
          }`}
        >
          {question}
        </h3>

        <div
          className={`overflow-hidden transition-all duration-700`}
          style={{
            maxHeight: isOpen ? "999px" : "0px"
          }}
        >
          <p className="mt-2">
            <span className="font-semibold">Answer: </span>
            {answer}
          </p>
        </div>
      </div>

      <div className={`rounded-full p-1 ${isOpen ? "bg-primary-blue/20" : ""}`}>
        <AnimatePresence mode="wait">
          {isOpen ? (
            <motion.div
              key="minus"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.1 }}
            >
              <Minus className="text-primary-blue min-w-5 min-h-5" />
            </motion.div>
          ) : (
            <motion.div
              key="plus"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.1 }}
            >
              <Plus className="text-primary-blue min-w-5 min-h-5" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FAQCard;
